import { IProduct } from '@/models/products.model';

type TBuildProductOptions = {
  options: {
    label: string;
    value: string;
  }[];
  label: string;
  value: string;
};

export const getProductList = (productsList?: IProduct[]) => {
  if (productsList) {
    return productsList.map((item) => {
      return {
        value: item.id,
        label: `${item.sku} (${item.name})` as string,
      };
    });
  }
  return [];
};

export const buildProductOptions = ({ options, label, value }: TBuildProductOptions) => {
  const isExists = options.some((option) => option.value === value);

  return isExists ? options : [{ label, value }, ...options];
};
